(function () {
  if (!matchMedia('(max-width: 749px)').matches) return;
  if (document.documentElement.getAttribute('data-ab-mpdp-velanio') !== 'b') return;
    function plaats() {
    document.querySelectorAll('.product__info-container product-form').forEach(function (pf) {
      var blok = pf.parentElement;
      var prev = blok.previousElementSibling;
      if (prev && prev.classList.contains('vm-last')) return;
      var el = document.createElement('p');
      el.className = 'vm-last';
      el.innerHTML = '<span class="vm-last__dot" aria-hidden="true"></span><span>Derniers articles disponibles</span>';
      blok.insertAdjacentElement('beforebegin', el);
    });
  }
    var STER = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10 1.3l2.6 5.5 6 .7-4.4 4.1 1.2 5.9L10 14.6l-5.4 2.9 1.2-5.9L1.4 7.5l6-.7z"/></svg>';
  function sterren() {
    document.querySelectorAll('.product__info-container > .product__title').forEach(function (t) {
      var prev = t.previousElementSibling;
      if (prev && prev.classList.contains('vm-rating')) return;
      var el = document.createElement('div');
      el.className = 'vm-rating';
      el.innerHTML = '<span class="vm-rating__stars" aria-label="5 étoiles sur 5">' + STER + STER + STER + STER + STER +
        '</span><span>Fantastique (1\u202f593 Commentaires)</span>';
      t.insertAdjacentElement('beforebegin', el);
    });
  }
    function melding() {
    document.querySelectorAll('.product__info-container .cx-usp3').forEach(function (usp) {
      var blok = usp;
      while (blok.parentElement && !blok.parentElement.classList.contains('product__info-container')) blok = blok.parentElement;
      var next = blok.nextElementSibling;
      if (next && next.classList.contains('vm-attn')) return;
      var el = document.createElement('div');
      el.className = 'vm-attn';
      el.innerHTML = '<b>ATTENTION\u00a0:</b> Cet article est l\u2019un de nos produits les plus vendus. ' +
        'Si vous pouvez encore l\u2019ajouter \u00e0 votre panier, cela signifie qu\u2019il est toujours en stock.';
      blok.insertAdjacentElement('afterend', el);
    });
  }
    var AANKONDIGING = 'BLACK FRIDAY EN AVANT-PREMI\u00c8RE\u202f: JUSQU\u2019\u00c0 -50\u202f%';
  function aankondiging() {
    document.querySelectorAll('[id$="__announcement-bar"] .announcement-bar__message').forEach(function (m) {
      var doel = m.querySelector('span') || m;
      if (doel.textContent !== AANKONDIGING) doel.textContent = AANKONDIGING;
    });
  }
  function alles() { plaats(); sterren(); melding(); aankondiging(); }
  alles();
  new MutationObserver(alles).observe(document.body, { childList: true, subtree: true });
})();
